import React from 'react';
import useAuth from '../../../hooks/useAuth';
import styles from './Navbar.module.css';

const Navbar = ({ title }) => {
  const { user } = useAuth();

  return (
    <div className={styles.navbar}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.userInfo}>
        <span className={styles.userEmail}>{user?.email}</span>
        <div className={styles.avatar}>
          {user?.email?.charAt(0).toUpperCase()}
        </div>
      </div>
    </div>
  );
};

export default Navbar;